class RelatedProducts {
	constructor() {
		this.products = document.querySelectorAll(".related-product");
		if (this.products.length) {
			this.buildcloseEvent();
		}
		this.tooltipOpened = false;
		this.products.forEach(product => {
			product.icon = product.querySelector(".icon");
			product.tooltip = product.querySelector(".tooltip-container");
		});
		this.buildEvents();
	}

	buildEvents() {
		this.products.forEach(product => {
			product.icon.addEventListener("click", () => {
				this.closeOthers(product);
			});
		});
	}

	closeOthers(currentProduct) {
		this.tooltipOpened = true;
		this.products.forEach(product => {
			if (currentProduct === product) {
				product.tooltip.classList.add("active");
				const rect = product.tooltip.getBoundingClientRect();
				if (rect.x < 5) {
					gsap.set(product.tooltip, {
						x: `+=${-rect.x + 30}px`
					});
				} else if (rect.x + rect.width > window.innerWidth) {
					gsap.set(product.tooltip, {
						x: `-=${rect.x + rect.width - window.innerWidth + 30}px`
					});
				}
			} else {
				product.tooltip.classList.remove("active");
			}
		});
	}

	buildcloseEvent() {
		document.addEventListener("click", e => {
			if (this.tooltipOpened) {
				if (!e.target.closest(".related-product")) {
					this.closeOthers();
				}
			}
		});
	}
}
